<template>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mb-4">
        <Head :title="topic.name" />
        <piped-title
            :first="$t('apartments.apartment') + ' ' + apartment.number"
            :second="topic.name"
            :pages="breadcrumbPages"
        ></piped-title>
    </div>

    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <!-- Topic Header -->
        <topics-header
            :topic="topic"
            :supplier="supplier"
            :supplier-contact="supplierContact"
            :supplier-show-link="
                supplier
                    ? route('advisors.suppliers.show', { supplier: supplier.uuid })
                    : null
            "
            :edit-deadline-link="
                route('advisors.topics.editDeadline', { topic: topic.uuid })
            "
            :edit-supplier-link="
                route('advisors.topics.editSupplier', { topic: topic.uuid })
            "
            :edit-budget-link="route('advisors.topics.editBudget', { topic: topic.uuid })"
            :show-budget="showBudget"
        ></topics-header>

        <!-- Info Bar Section -->
        <topics-infobar :topic="topic" edit-state-route="advisors.topics.editState" />

        <!-- Order Modifications Section -->

        <order-modification-table
            :topic="topic"
            :order-modifications="orderModifications"
            create-modification-route="advisors.topics.order-modifications.create"
            show-modification-route="advisors.topics.order-modifications.show"
            :show-budget="showBudget"
            :is-budget-based="isBudgetBased"
        />

        <!-- Offers Section -->
<!--        <offer-table-->
<!--            :topic="topic"-->
<!--            :offers="offers"-->
<!--            create-offer-route="advisors.topics.offers.create"-->
<!--            delete-offer-route="advisors.topics.offers.delete"-->
<!--            update-offer-route="advisors.topics.offers.update"-->
<!--            reject-offer-route="advisors.topics.offers.showReject"-->
<!--            edit-offer-route="advisors.topics.offers.edit"-->
<!--            replace-offer-route="advisors.topics.offers.showReplace"-->
<!--            history-offer-route="advisors.topics.offers.viewOfferHistory"-->
<!--        />-->

        <!-- Option-Sets Section -->
        <set-selection
            v-for="values in sets"
            :disabled="topic.state === 'completed'"
            :topic="topic"
            route-for-select="advisors.topics.sets.select"
            route-for-clear="advisors.topics.sets.clear"
            :values="values"
            :key="values.set.uuid"
        />

        <!-- Documents Section -->
        <document-table :documents="documents"></document-table>
    </div>
</template>

<script>
import ApartmentLayout from "@/Layouts/ApartmentLayout";
import PipedTitle from "@/Shared/Components/PipedTitle";
import { Head } from "@inertiajs/inertia-vue3";
import {
    CheckIcon,
    CloudDownloadIcon,
    CloudUploadIcon,
    PaperAirplaneIcon,
    RefreshIcon,
    TagIcon,
    TrashIcon,
    XIcon
} from "@heroicons/vue/outline";
import OfferTable from "@/Pages/Topics/Components/OfferTable";
import DocumentTable from "@/Shared/Components/Documents/DocumentTable";
import SetSelection from "@/Pages/Apartments/Components/SetSelection";
import TopicsHeader from "@/Shared/Components/Topics/TopicsHeader";
import TopicsInfobar from "@/Shared/Components/Topics/TopicsInfobar";
import OrderModificationTable from "@/Pages/Topics/Components/OrderModificationTable.vue";

export default {
    components: {
        Head,
        TopicsInfobar,
        OfferTable,
        OrderModificationTable,
        DocumentTable,
        PipedTitle,
        SetSelection,
        CloudUploadIcon,
        CloudDownloadIcon,
        TrashIcon,
        PaperAirplaneIcon,
        RefreshIcon,
        CheckIcon,
        XIcon,
        TagIcon,
        TopicsHeader
    },
    layout: ApartmentLayout,
    props: [
        "topic",
        "apartment",
        "supplier",
        "supplierContact",
        "documents",
        "sets",
        "project",
        "orderModifications",
        // Auftrag 2026-08-16, Entscheid 7: der Berechnungsmodus reist als
        // SEITEN-Prop mit, nicht über HandleInertiaRequests.
        "feeCalculation"
    ],
    computed: {
        // Zielgruppe dieser Seite ist "intern" — der Spaltensatz ist im
        // `FeeCalculationResource` bereits dafür aufgelöst. Fehlt die Prop,
        // bleibt die Seite vollständig (Bestandsverhalten).
        showBudget() {
            return this.feeCalculation ? this.feeCalculation.showBudget : true;
        },
        isBudgetBased() {
            return this.feeCalculation ? this.feeCalculation.isBudgetBased : false;
        },
        breadcrumbPages() {
            return [
                {
                    name: this.$t("projects.projects"),
                    href: this.route("advisors.projects.index"),
                    current: false
                },
                {
                    name: this.project.name,
                    href: this.route("advisors.projects.show", {
                        uuid: this.project.uuid
                    }),
                    current: false
                },
                {
                    name: `${this.$t("apartments.apartment")} ${this.apartment.number}`,
                    href: this.route("advisors.apartments.show", this.apartment.uuid),
                    current: true
                }
            ];
        }
    }
};
</script>

<style scoped></style>
